import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'admin-layout',
  templateUrl: './admin-layout.component.html',
})
export class AdminLayoutComponent implements OnInit {

  constructor(
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    console.log(this.route.children);
    if(this.route.children.length == 0)
      this._router.navigate(['/home']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/_admin-layout/admin-layout.component.ts